import { Component } from 'preact'

export default class SVG extends Component {
  componentWillMount() {
    Missive.injectSVGIcon(this.props.name)
  }

  render() {
    let { name, size, width, height, badge, badgeSize, fill } = this.props

    size || (size = 24)
    width || (width = size)
    height || (height = size)

    let style = { width, height }

    if (badge && badgeSize) {
      style.fontSize = badgeSize
      style.marginRight = `${badge.toString().length}em`
    }

    return (
      <i class={`icon icon-${name}`} style={style} data-badge={badge}>
        <svg style={{ width: size, height: size, fill }}>
          <use xlinkHref={`#${name}`} />
        </svg>
      </i>
    )
  }
}
